import { render, staticRenderFns } from "./PerformancePatrol.vue?vue&type=template&id=e4b5e766&scoped=true"
import script from "./PerformancePatrol.vue?vue&type=script&lang=js"
export * from "./PerformancePatrol.vue?vue&type=script&lang=js"
import style0 from "./PerformancePatrol.vue?vue&type=style&index=0&id=e4b5e766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b5e766",
  null
  
)

export default component.exports